import { createSelector } from 'reselect';

/**
 * Direct selector to the auth state domain
 */
export const selectAuthState = () => (state) => state.get('auth');

/**
 * Select the auth state
 */

export const selectLoading = () => createSelector(selectAuthState(), (substate) => substate.get('loading'));

export const selectProfile = () => createSelector(selectAuthState(), (substate) => substate.getIn('user', 'profile'));

export const selectUser = () => createSelector(selectAuthState(), (substate) => substate.get('user'));

export const selectDealershipId = () =>
  createSelector(selectAuthState(), (substate) => substate.get('user')?.profile.dealership.id);

export const selectDealership = () =>
  createSelector(selectAuthState(), (substate) => substate.get('user')?.profile.dealership);

export const selectErrors = () => createSelector(selectAuthState(), (substate) => substate.get('errors'));

export const selectUnauthorized = () => createSelector(selectAuthState(), (substate) => substate.get('unauthorized'));

export const selectNetworkError = () => createSelector(selectAuthState(), (substate) => substate.get('networkError'));

export const selectTokenAuthorized = () =>
  createSelector(selectAuthState(), (substate) => substate.get('tokenAuthorized'));

export const selectContactlessToken = () =>
  createSelector(selectAuthState(), (substate) => substate.get('contactlessAuthToken'));
